import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { ACTION_TYPES, getPriceStr } from "./utils"
import $ from 'jquery'
import _ from 'lodash'
import { useLocation } from "@reach/router"

export { ACTION_TYPES, ACTION_DESC_TYPES, getPriceStr } from "./utils";


const SeoResults = ({ description, lang, meta, title, searchParams, location, pcategorytype }) => {
  const { areas, bedrooms, pType, type, price, commType } = searchParams;

  const actionStr = ACTION_TYPES[pType];
  const priceStr = getPriceStr(price)
  const bedRooms = searchParams.bedrooms
  const [isNoResult, setIsNoResult] = useState(false)
  const [stateMetaItems, setMetaItems] = useState([])

  let propertyType = ""

  if (type == "") {
    propertyType = "Property "
  } else {
    propertyType = "Property " + type
  }

  const capitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
  }

  const { pathname } = useLocation()

  var curentUrl = '';
  curentUrl = process.env.GATSBY_SITE_URL+pathname;

  // set no index for result pagination
  let hasPagination = false;
  if (pathname !== undefined && pathname) {
    let pageStr = pathname.split('page-');
    hasPagination = pageStr[1] || false;
    if (pageStr[0] !== undefined) {
     curentUrl = process.env.GATSBY_SITE_URL + pageStr[0];
    }
  }

  if (!curentUrl.endsWith('/'))
        curentUrl = curentUrl + '/';

  //remove multiple slashes
  curentUrl = curentUrl.replace(/([^:]\/)\/+/g, "$1");
  //set lowercase url
  curentUrl = curentUrl.toLowerCase();
    
  let titlePropertyType = ""

  if (type == "") {
    titlePropertyType = "Property"
  } else if (type == "apartment") {
    titlePropertyType = "Apartments"
  } else if (type == "house") {
    titlePropertyType = "Houses"
  } else if (type == "maisonette") {
    titlePropertyType = "Maisonettes"
  } else if (type == "property") {
    titlePropertyType = "Property"
  } else if (type == "bungalow") {
    titlePropertyType = "Bungalows"
  } else if (type == "land") {
    titlePropertyType = "Lands"
  } else if (type == "commercial") {
    titlePropertyType = "Commercial"
  } else {
    titlePropertyType = type
  }

  let bedroomType = ""

  if (bedrooms) {
    bedroomType = bedrooms + ' + Bedroom '
  }

  let descTitle = bedroomType + capitalize(titlePropertyType) + actionStr + capitalize(areas) + priceStr
  //

  // console.log("Props Desc => ", desc); 

  let metaItems = [
    {
      name: `description`,
      content: description,
    },
    {
      property: `og:title`,
      content: descTitle,
    },
    {
      property: `og:description`,
      content: description,
    },
    {
      property: `og:type`,
      content: `website`,
    },
    {
      name: `og:url`,
      content: curentUrl,
    },
    {
      name: `twitter:card`,
      content: `summary`,
    },
    {
      name: `twitter:creator`,
      content: `DB Roberts`,
    },
    {
      name: `twitter:title`,
      content: descTitle,
    },
    {
      name: `twitter:description`,
      content: description,
    },
  ].concat(meta);


  // set no index for result pagination
  if ( hasPagination ) {
    // metaItems.push({
    //   name: `robots`,
    //   content: `noindex`,
    // })
  }


  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={descTitle}
      titleTemplate={`${title} | DB Roberts`}
      link={[
        {
          href: curentUrl,
          rel: "canonical"
        }]}
      meta={metaItems}
    />
  )
}

SeoResults.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
  title: ``,
  searchParams: [],
}

SeoResults.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  searchParams: PropTypes.any,
}

export default SeoResults
